(function () {
  const SORT_VALUE = 'discount-desc';
  const SORT_LABEL = 'Største rabatt';
  const SECTION_ID = 'template--21840931455191__main';

  // ── 1. Hent collection handle fra URL ────────────────────────────────────
  function getHandle() {
    const pathParts = window.location.pathname.split('/');
    const collIndex = pathParts.indexOf('collections');
    return collIndex !== -1 ? pathParts[collIndex + 1] : null;
  }

  // ── 2. Inject sort-option ─────────────────────────────────────────────────
  function injectSortOption() {
    const list = document.querySelector('#sort-list[data-popout-list]');
    if (!list || list.querySelector(`[data-value="${SORT_VALUE}"]`)) return;

    const li = document.createElement('li');
    li.className = 'popout-list__item';
    li.innerHTML = `
      <a class="popout-list__option" data-value="${SORT_VALUE}" href="#" data-sort-link="">
        <span>${SORT_LABEL}</span>
      </a>
    `;
    list.appendChild(li);

    li.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      activateDiscountSort(this);
    });

    if (new URLSearchParams(window.location.search).get('sort_by') === SORT_VALUE) {
      setButtonText(SORT_LABEL);
      li.classList.add('popout-list__item--current');
      runSort();
    }
  }

  // ── 3. UI-helpers ─────────────────────────────────────────────────────────
  function setButtonText(text) {
    const btn = document.querySelector('[data-sort-button-text]');
    if (btn) btn.textContent = text;
  }

  function clearCurrentClass() {
    document.querySelectorAll('.popout-list__item--current').forEach((el) => {
      el.classList.remove('popout-list__item--current');
    });
  }

  function showLoader(grid) {
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';
  }

  function hideLoader(grid) {
    grid.style.opacity = '';
    grid.style.pointerEvents = '';
  }

  function getProductsPerPage() {
    const cards = document.querySelectorAll('.js-grid .product-grid-item');
    return cards.length || 24;
  }

  function activateDiscountSort(anchor) {
    clearCurrentClass();
    anchor.closest('.popout-list__item').classList.add('popout-list__item--current');
    setButtonText(SORT_LABEL);

    const popout = document.querySelector('[data-sort-enabled]');
    if (popout) popout.dataset.sortEnabled = SORT_VALUE;

    const toggle = document.querySelector('[data-popout-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', SORT_VALUE);
    window.history.pushState({}, '', url.toString());

    runSort();
  }

  // ── 4. Hent alle produkter via products.json ──────────────────────────────
  async function fetchAllProducts(handle) {
    let products = [];
    let page = 1;

    while (true) {
      const res = await fetch(
        `/collections/${handle}/products.json?limit=250&page=${page}`
      );
      const data = await res.json();
      if (!data.products?.length) break;
      products = products.concat(data.products);
      if (data.products.length < 250) break;
      page++;
    }

    console.log(`[discount-sort] Hentet totalt ${products.length} produkter`);
    return products;
  }

  // ── 5. Regn ut høyeste rabatt per produkt ────────────────────────────────
  function getMaxDiscount(product) {
    let max = 0;
    for (const variant of product.variants) {
      const price = parseFloat(variant.price);
      const compare = parseFloat(variant.compare_at_price);
      if (compare && compare > price) {
        const pct = ((compare - price) / compare) * 100;
        if (pct > max) max = pct;
      }
    }
    return max;
  }

  // ── 6. Hent alle produktkort via Section Rendering API ───────────────────
  async function fetchAllCards(handle, totalProducts, perPage) {
    const totalPages = Math.ceil(totalProducts / perPage);
    console.log(`[discount-sort] Henter ${totalPages} sider (${totalProducts} produkter, ${perPage} per side)`);

    const pagePromises = [];
    for (let page = 1; page <= totalPages; page++) {
      pagePromises.push(
        fetch(`/collections/${handle}?section_id=${SECTION_ID}&page=${page}&sort_by=best-selling`)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('.product-grid-item'));
          })
      );
    }

    const pages = await Promise.all(pagePromises);
    const allCards = [];
    pages.forEach(cards => allCards.push(...cards));
    console.log(`[discount-sort] Totalt ${allCards.length} kort hentet`);
    return allCards;
  }

  // ── 7. Hovedlogikk for sortering ─────────────────────────────────────────
  async function runSort() {
    const grid = document.querySelector('.js-grid');
    if (!grid) return;

    const perPage = getProductsPerPage();
    showLoader(grid);

    const handle = getHandle();
    if (!handle) { hideLoader(grid); return; }

    try {
      const products = await fetchAllProducts(handle);

      const discountMap = {};
      products.forEach((p) => {
        discountMap[String(p.id)] = getMaxDiscount(p);
      });

      const allCards = await fetchAllCards(handle, products.length, perPage);

      allCards.sort((a, b) => {
        const idA = a.dataset.itemId || '';
        const idB = b.dataset.itemId || '';
        return (discountMap[idB] || 0) - (discountMap[idA] || 0);
      });

      const fragment = document.createDocumentFragment();
      allCards.forEach((card) => {
        card.style.transform = '';
        card.style.opacity = '';
        card.style.transition = 'none';
        fragment.appendChild(card);
      });

      while (grid.firstChild) grid.removeChild(grid.firstChild);
      grid.appendChild(fragment);

      document.querySelectorAll('.pagination, [data-pagination]').forEach((el) => {
        el.style.display = 'none';
      });

    } catch (err) {
      console.error('[discount-sort] Feil:', err);
    }

    hideLoader(grid);
  }

  // ── 8. Setup observers ────────────────────────────────────────────────────
  function setupObservers() {
    const sortObserver = new MutationObserver(() => {
      const list = document.querySelector('#sort-list[data-popout-list]');
      if (list && !list.querySelector(`[data-value="${SORT_VALUE}"]`)) {
        injectSortOption();
      }
    });
    const sortContainer = document.querySelector('.collection-sort');
    if (sortContainer) {
      sortObserver.observe(sortContainer, { childList: true, subtree: true });
    }
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    injectSortOption();
    setupObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();